import React from "react";
export const PregrafosConfigurationContext = React.createContext(null);
export const PregrafosConfigurationProvider = React.memo(function PregrafosConfigurationProvider({ initialValue, children }) {
    return (React.createElement(PregrafosConfigurationContext.Provider, { value: initialValue }, children));
});
//# sourceMappingURL=PregrafosConfigurationContext.js.map